// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab658c92","455":"5c438e2c","977":"cafd8f81"}[chunkId] + ".chunk.js";
};